export const initialIntermediateCeilingState = {
    blockOuts: [],
    circularBlockOuts: []
}
